const escrowWalletDE = {
    "view": {
        "title": "Verwalten Sie Ihr Treuhandkonto",
        "descriptionParagraph1": "Gelder werden einbehalten, um Sicherheit und Transparenz während des Verifizierungsprozesses zu gewährleisten. Für markierte Tracks wird eine Gebühr von <strong>15 €</strong> pro Track im Treuhandkonto einbehalten, um den Track für die Lieferung an Spotify auf die Whitelist zu setzen. Diese Gelder werden zurückerstattet, sobald die Künstler des Tracks als legitim verifiziert sind.",
        "descriptionParagraph2": "Verwenden Sie die folgende Tabelle, um alle Treuhandtransaktionen anzuzeigen. Für weitere Details, <1><strong>Erfahren Sie mehr</strong></1>",
        "label": {
            "totalWithheld": "Insgesamt Einbehalten",
            "totalRefunds": "Gesamte Rückerstattungen"
        },
        "escrowPayments": {
            "title": "Treuhandzahlungen",
            "table": {
                "column": {
                    "paymentId": "Zahlungs-ID",
                    "releaseName": "Veröffentlichung",
                    "amount": "Betrag",
                    "paymentDate": "Zahlungsdatum",
                    "paymentAgreement": "Zahlungsvereinbarung",
                    "refundProcessed": "Rückerstattung Bearbeitet",
                    "requestRefund": "Rückerstattung Anfordern",
                    "details": "Details"
                },
                "placeholder": {
                    "search": "Suchen..."
                },
                "button": {
                    "download": "Herunterladen",
                    "exportCsv": "CSV exportieren",
                    "view": "Ansehen",
                    "requestRefund": "Rückerstattung Anfordern"
                },
                "label": {
                    "notAvailable": "Nicht Verfügbar"
                },
                "modal": {
                    "requestRefund": {
                        "header": "Rückerstattung Anfordern",
                        "body": {
                            "description": "Sind Sie sicher, dass Sie eine Rückerstattung für diese Zahlung anfordern möchten?",
                            "note": "Bitte beachten Sie, dass diese Anfrage von der Verwaltung überprüft wird und, wenn genehmigt, als Abrechnung hinzugefügt wird, für die Sie eine Rechnung ausstellen können."
                        },
                        "button": {
                            "confirm": "Bestätigen",
                            "cancel": "Abbrechen"
                        },
                        "message": {
                            "success": "Rückerstattungsanfrage erfolgreich eingereicht!",
                            "error": "Etwas ist schief gelaufen, bitte versuchen Sie es später erneut!"
                        }
                    }
                }
            }
        },
        "escrowPaymentBreakdown": {
            "title": "Aufschlüsselung der Treuhandzahlungen",
            "table": {
                "column": {
                    "paymentId": "Zahlungs-ID",
                    "trackName": "Track",
                    "amount": "Betrag",
                    "paymentDate": "Zahlungsdatum"
                }
            }
        },
        "escrowRefunds": {
            "title": "Treuhandrückerstattungen",
            "table": {
                "column": {
                    "refundId": "Rückerstattungs-ID",
                    "paymentId": "Zahlungs-ID",
                    "release": "Veröffentlichung",
                    "amount": "Betrag",
                    "requestDate": "Antragsdatum",
                    "status": "Status"
                },
                "label": {
                    "pending": "Ausstehend",
                    "approved": "Genehmigt",
                    "rejected": "Abgelehnt"
                },
                "tooltip": {
                    "pending": "Ihre Rückerstattungsanfrage wird derzeit von der Verwaltung überprüft und wird bald bearbeitet.",
                    "approved": "Ihre Rückerstattungsanfrage wurde genehmigt und eine Abrechnung für den Rückerstattungsbetrag wurde hinzugefügt.",
                    "rejected": "Ihre Rückerstattungsanfrage wurde von der Verwaltung abgelehnt, Sie können erneut eine Rückerstattung anfordern."
                },
                "placeholder": {
                    "search": "Suchen..."
                },
                "button": {
                    "exportCsv": "CSV exportieren"
                }
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transaktion Erfolgreich :)",
            "description": "Die Treuhandzahlung wurde erfolgreich abgeschlossen, die entsprechende Veröffentlichung wird in Kürze auf die Whitelist gesetzt!",
            "button": {
                "returnToDashboard": "Zurück zum Dashboard"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transaktion Abgebrochen :(",
            "description": "Die Transaktion wurde abgebrochen... Bitte versuchen Sie es später erneut!",
            "button": {
                "returnToDashboard": "Zurück zum Dashboard"
            }
        }
    }
};

export default escrowWalletDE;